import App from 'next/app';
import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { BrowserRouter, matchPath } from 'react-router-dom';
import { Provider } from 'react-redux';
import getConfig from 'next/config';

import withReduxStore from '../lib/with-redux-store';
import withModularReduxStore from '../lib/with-modular-redux-store';
import { getSearchParam } from '../helpers/getSearchParam.ts';
import { sanitizeUrl, ModularReduxContext, ReduxContext } from '../helpers';
import { RESET_PASSWORD_ROUTE } from './webreg';
import { AnalyticsScripts } from '../components/AnalyticsLoader/index.ts';
import ErrorBoundary from '../components/ErrorBoundary/index.tsx';

const { publicRuntimeConfig } = getConfig();
class MyApp extends App {
  constructor() {
    super(...arguments);
    this.state = {
      errorEventId: undefined,
      cleanedUrl: false,
      accessToken: '',
      authToken: ''
    };
  }

  componentDidMount() {
    const resetPasswordMatch = matchPath(window.location.pathname, {
      path: RESET_PASSWORD_ROUTE
    });
    // Save authToken and accessToken from url and then remove from url to prevent analytics from seeing them
    this.setState({
      authToken: getSearchParam('authToken'),
      accessToken: getSearchParam('accessToken'),
      role: resetPasswordMatch
        ? resetPasswordMatch.params.type
        : this.props.pageProps.query?.role,
      userId: resetPasswordMatch ? resetPasswordMatch.params.uid : undefined,
      resetToken: resetPasswordMatch
        ? resetPasswordMatch.params.token
        : undefined
    });

    window.history.replaceState(
      {},
      null,
      sanitizeUrl({
        url: window.location.href,
        queryParams: ['authToken', 'accessToken'],
        pathParams: [
          { path: RESET_PASSWORD_ROUTE, paramsToRemove: ['uid', 'token'] }
        ]
      })
    );
    this.setState({ cleanedUrl: true });
  }

  render() {
    const { Component, pageProps, reduxStore, modularReduxStore } = this.props;

    pageProps.authToken = this.state.authToken;
    pageProps.accessToken = this.state.accessToken;
    pageProps.userId = this.state.userId;
    pageProps.resetToken = this.state.resetToken;
    pageProps.role = this.state.role;

    if (!this.state.cleanedUrl) {
      return <div />;
    }

    return (
      <>
        <Head>
          <title>Greenlight Registration</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
          />
          {publicRuntimeConfig.nodeEnv !== 'production' && (
            <meta name="robots" content="noindex" />
          )}
        </Head>
        <AnalyticsScripts
          segmentWriteKey={publicRuntimeConfig.segmentKey}
          pageCategory="Registration"
          pageName="Web Registration"
          anonymousId={pageProps.anonymousId}
        />
        <ErrorBoundary>
          <BrowserRouter>
            <Provider store={reduxStore} context={ReduxContext}>
              <ModularReduxContext.Provider value={modularReduxStore}>
                <Component {...pageProps} />
              </ModularReduxContext.Provider>
            </Provider>
          </BrowserRouter>
        </ErrorBoundary>
      </>
    );
  }
}

export default withModularReduxStore(
  withReduxStore(dynamic(async () => MyApp, { ssr: false }))
);
